
import { useState, useEffect } from 'react';
import { getLiveCategorys } from '../../services/live';
import { useSelector } from 'react-redux';
import type { RootState } from '../../store';
export default function Footer() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [displayCategories, setDisplayCategories] = useState<any[]>([]);
  // 监听页面滚动
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
    useEffect(() => {
    getLiveCategorys().then((res: any) => {
      if (res && res.status === 1 && Array.isArray(res.data)) {
        const liveCategoryNames = new Set(res.data.map((c: any) => c.name));
        const filtered = sportsCategories.filter(c => liveCategoryNames.has(c.name));
        setDisplayCategories(filtered);
      }
    });
  }, []);
  const { configInfo } = useSelector((state: RootState) => state.settings);

  const handleOpenUrl = (e: React.MouseEvent, url?: string) => {
    e.preventDefault();
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };
  const quickLinks = [
    { name: '关于我们', path: '/about', icon: 'ri-information-line' },
    { name: '联系方式', path: '/contact', icon: 'ri-customer-service-line' },
    { name: '帮助中心', path: '/help', icon: 'ri-question-line' },
    { name: '隐私政策', path: '/privacy', icon: 'ri-shield-line' },
    { name: '用户协议', path: '/terms', icon: 'ri-file-text-line' },
  ];

  const sportsCategories = [
    { name: '足球', icon: 'ri-football-line' },
    { name: '篮球', icon: 'ri-basketball-line' },
    { name: '网球', icon: 'ri-ping-pong-line' },
    { name: '乒乓球', icon: 'ri-ping-pong-line' },
    { name: '羽毛球', icon: 'ri-ping-pong-line' },
    { name: '排球', icon: 'ri-basketball-line' },
    { name: 'F1赛车', icon: 'ri-car-line' },
    { name: '游泳', icon: 'ri-water-flash-line' },
    { name: '田径', icon: 'ri-run-line' },
    { name: '高尔夫', icon: 'ri-golf-ball-line' },
    { name: '拳击', icon: 'ri-boxing-line' },
    { name: '体操', icon: 'ri-medal-line' },
    { name: '台球', icon: 'ri-billiards-line' },
    { name: '电竞', icon: 'ri-gamepad-line' },
    { name: '马术', icon: 'ri-horse-line' },
    { name: '冰球', icon: 'ri-hockey-puck-line' }
  ];

  const socialLinks = [
    { name: '微信', icon: 'ri-wechat-line', url: '#' },
    { name: '微博', icon: 'ri-weibo-line', url: '#' },
    { name: '抖音', icon: 'ri-tiktok-line', url: '#' },
    { name: 'QQ', icon: 'ri-qq-line', url: '#' }
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
      {/* 背景装饰 */}
      <div className="absolute inset-0 bg-gradient-to-r from-green-500/5 to-blue-500/5"></div>
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-green-500/3 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-500/3 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 py-12 relative">
        {/* 主要内容区域 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          {/* 品牌信息 */}
          <div className="lg:col-span-2">
            <div className="mb-6 flex items-center space-x-3">
              <div className="w-12 h-12 bg-gradient-to-r from-green-400 to-blue-400 rounded-xl flex items-center justify-center">
                <i className="ri-tv-line text-white text-xl"></i>
              </div>
              <div>
                <span className="text-2xl font-bold bg-gradient-to-r from-green-400 to-blue-400 bg-clip-text text-transparent">
                  贝斯特体育
                </span>
                <p className="text-sm text-gray-400">专业体育直播平台</p>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-6 max-w-md">
              为全球体育爱好者提供最新的体育赛事直播、精彩回放和用户自主直播服务。实时更新，精彩不断，与您共享体育的激情与魅力。
            </p>
            
            {/* 社交媒体 */}
            <div className="mb-6">
              <h4 className="font-semibold mb-3 text-white">关注我们</h4>
              <div className="flex items-center space-x-3">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.url}
                    onClick={(e) => 
                    {
                      if(social.name == '微信') {  
                        handleOpenUrl(e, configInfo?.service_wechat);
                      } else if(social.name == 'QQ') {
                        handleOpenUrl(e, configInfo?.service_qq);
                      }
                    }}
                    className="w-10 h-10 bg-gray-700 hover:bg-gradient-to-r hover:from-green-500 hover:to-blue-500 rounded-lg flex items-center justify-center transition-all duration-300 group"
                    title={social.name}
                  >
                    <i className={`${social.icon} text-gray-300 group-hover:text-white transition-colors`}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* 下载APP */}
            <div className="flex items-center space-x-4">
              <div className="bg-gray-800 rounded-lg p-3 flex items-center space-x-3 hover:bg-gray-700 transition-colors cursor-pointer">
                <div className="w-8 h-8 bg-gradient-to-r from-green-400 to-blue-400 rounded flex items-center justify-center">
                  <i className="ri-smartphone-line text-white text-sm"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-400">下载APP</p>
                  <p className="text-sm font-medium text-white">手机观看</p>
                </div>
              </div>
            </div>
          </div>

          {/* 快速导航 */}
          <div>
            <h4 className="font-semibold mb-6 text-white flex items-center">
              <div className="w-1 h-6 bg-gradient-to-b from-green-400 to-blue-400 rounded-full mr-3"></div>
              快速导航
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a 
                    href={link.path}
                    className="text-gray-300 hover:text-white cursor-pointer text-sm transition-colors duration-200 flex items-center group"
                  >
                    <i className={`${link.icon} mr-2 text-gray-400 group-hover:text-green-400 transition-colors`}></i>
                    <span className="group-hover:translate-x-1 transition-transform duration-200">
                      {link.name}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 体育分类 - 重新设计 */}
          <div>
            <h4 className="font-semibold mb-6 text-white flex items-center">
              <div className="w-1 h-6 bg-gradient-to-b from-green-400 to-blue-400 rounded-full mr-3"></div>
              体育分类
            </h4>
            
            {/* 热门分类 - 显示前6个 */}
            <div className="mb-4">
              <div className="grid grid-cols-2 gap-2">
                {displayCategories.slice(0, 6).map((sport) => (
                  <a 
                    key={sport.name}
                    href={`/sports/${sport.name}`}
                    className="text-gray-300 hover:text-white cursor-pointer text-sm transition-colors duration-200 flex items-center group py-1"
                  >
                    <i className={`${sport.icon} mr-2 text-gray-400 group-hover:text-blue-400 transition-colors text-xs`}></i>
                    <span className="group-hover:translate-x-1 transition-transform duration-200 truncate">
                      {sport.name}
                    </span>
                  </a>
                ))}
              </div>
            </div>
            
            {/* 更多分类按钮 */}
            <div className="relative group">
              <button className="w-full text-left bg-gray-800 hover:bg-gray-700 rounded-lg p-3 transition-all duration-200 border border-gray-700 hover:border-gray-600">
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <i className="ri-more-line text-gray-400 group-hover:text-blue-400 mr-2"></i>
                    <span className="text-sm text-gray-300 group-hover:text-white">更多体育项目</span>
                  </div>
                  <i className="ri-arrow-right-s-line text-gray-400 group-hover:text-blue-400 group-hover:translate-x-1 transition-all"></i>
                </div>
              </button>
              
              {/* 下拉菜单 */}
              <div className="absolute bottom-full left-0 w-72 bg-gray-800 border border-gray-700 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 mb-2 z-50">
                <div className="p-4">
                  <h5 className="text-sm font-medium text-white mb-3 flex items-center">
                    <i className="ri-trophy-line text-yellow-400 mr-2"></i>
                    全部体育项目
                  </h5>
                  <div className="grid grid-cols-2 gap-2 max-h-64 overflow-y-auto">
                    {displayCategories.map((sport) => (
                      <a 
                        key={sport.name}
                        href={`/sports/${sport.name}`}
                        className="text-gray-300 hover:text-white hover:bg-gray-700 cursor-pointer text-sm transition-all duration-200 flex items-center p-2 rounded group/item"
                      >
                        <i className={`${sport.icon} mr-2 text-gray-400 group-hover/item:text-blue-400 transition-colors text-xs`}></i>
                        <span className="truncate">
                          {sport.name}
                        </span>
                      </a>
                    ))}
                  </div>
                </div>
                
                {/* 箭头指示器 */}
                <div className="absolute top-full left-6 w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent border-r-transparent border-t-gray-800"></div>
              </div>
            </div>
          </div>

          {/* 联系信息 */}
          <div>
            <h4 className="font-semibold mb-6 text-white flex items-center">
              <div className="w-1 h-6 bg-gradient-to-b from-green-400 to-blue-400 rounded-full mr-3"></div>
              联系我们
            </h4>
            <div className="space-y-4">
              <div className="group">
                <div className="flex items-start text-gray-300 hover:text-white transition-colors duration-200 cursor-pointer">
                  <div className="w-8 h-8 bg-gray-700 group-hover:bg-green-500 rounded-lg flex items-center justify-center mr-3 transition-colors">
                    <i className="ri-mail-line text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 mb-1">邮箱地址</p>
                    <p className="text-sm">{configInfo?.service_email}</p>
                  </div>
                </div>
              </div>
              
              <div className="group">
                <div className="flex items-start text-gray-300 hover:text-white transition-colors duration-200 cursor-pointer">
                  <div className="w-8 h-8 bg-gray-700 group-hover:bg-blue-500 rounded-lg flex items-center justify-center mr-3 transition-colors">
                    <i className="ri-phone-line text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 mb-1">客服热线</p>
                    <p className="text-sm">{configInfo?.contact_info}</p>
                  </div>
                </div>
              </div>
              
              <div className="group">
                <div className="flex items-start text-gray-300 hover:text-white transition-colors duration-200 cursor-pointer">
                  <div className="w-8 h-8 bg-gray-700 group-hover:bg-purple-500 rounded-lg flex items-center justify-center mr-3 transition-colors">
                    <i className="ri-map-pin-line text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 mb-1">公司地址</p>
                    <p className="text-sm">北京市朝阳区体育大厦</p>
                  </div>
                </div>
              </div>
              
              {/* 24小时服务标识 */}
              <div 
              onClick={(e) => handleOpenUrl(e, configInfo?.live_url)}
               className="bg-gradient-to-r from-green-500/20 to-blue-500/20 border border-green-500/30 rounded-lg px-3 py-2 mt-4">
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse mr-2"></div>
                  <span className="text-xs text-green-300">24小时在线服务</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 分隔线 */}
        <div className="border-t border-gray-700/50 mb-8"></div>

        {/* 底部版权信息 */}
        <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
          <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
            <p className="text-gray-400 text-sm">
              © 2024 bstyx.com. 保留所有权利.
            </p>
            <div className="flex items-center space-x-4 text-xs text-gray-500">
              <span>ICP备案号: 京ICP备12345678号</span>
              <span>•</span>
              <span>网络文化经营许可证</span>
            </div>
          </div>
          
          <div className="flex items-center space-x-6">
            {/* 技术支持 */}
            <div className="flex items-center text-gray-400 text-sm">
              <i className="ri-code-line mr-2"></i>
              <span>技术支持</span>
            </div>
            
            {/* Made with Readdy */}
            {/* <a 
              href="https://readdy.ai/?origin=logo" 
              className="text-gray-400 hover:text-white text-sm cursor-pointer transition-colors duration-200 flex items-center group"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="w-6 h-6 bg-gradient-to-r from-green-400 to-blue-400 rounded-full flex items-center justify-center mr-2 group-hover:scale-110 transition-transform">
                <i className="ri-heart-line text-white text-xs"></i>
              </div>
              Made with Readdy
            </a> */}
          </div>
        </div>

        {/* 回到顶部按钮 */}
        {showScrollTop && (
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="fixed bottom-24 right-4 w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center group hover:scale-110 z-40 animate-fadeIn"
            aria-label="回到顶部"
          >
            <i className="ri-arrow-up-line group-hover:translate-y-[-2px] transition-transform"></i>
          </button>
        )}
      </div>
    </footer>
  );
}
